module.exports = __webpack_public_path__ + "img/cisco-1.50a84875.jpg";